/* ELDR Gutschein-Jagd – versteckte Tarotkarten
 * Holt den Kartenstatus vom Worker, zeigt die Jagd-Sektion auf der Startseite,
 * setzt die versteckten Symbole an ihre Spots, führt durch Fund → E-Mail → Code
 * und zeigt danach Timer-Anzeige und Hinweis im Warenkorb.
 */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-eldr-tarot-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  // Zum Testen kann die Worker-Adresse im eigenen Browser überschrieben werden: localStorage.eldrTarotApi
  var override = null;
  try { override = localStorage.getItem('eldrTarotApi'); } catch (e) {}
  var apiBase = override || cfg.api;
  if (!apiBase) return;
  var API = apiBase.replace(/\/+$/, '');
  var STORE_KEY = 'eldrTarotClaim';
  var DEVICE_KEY = 'eldrTarotDevice';

  var TURN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3"/><path d="M18 3v4h-4M6 21v-4h4"/></svg>';
  var SYM = {
    a: '<svg class="eldr-t-sym-svg" viewBox="0 0 48 48" aria-hidden="true"><path d="M12 8v32M36 8v32"/><path class="f" d="M27 15a9 9 0 1 0 0 18a5 9 0 1 1 0 -18z"/></svg>',
    b: '<svg class="eldr-t-sym-svg" viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="20" r="12"/><path class="f" d="M24 8a12 12 0 0 1 0 24a7 12 0 0 0 0 -24z"/><path d="M16 40h16M20 44h8"/></svg>',
    c: '<svg class="eldr-t-sym-svg" viewBox="0 0 48 48" aria-hidden="true"><path d="M24 4v6M19 10h10M17 14h14l-2 22H19z"/><path class="f" d="M24 19l3 5-3 5-3-5z"/><path d="M19 40h10"/></svg>'
  };

  /* ── kleine Hilfen ── */
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function deviceId() {
    var id = store(DEVICE_KEY);
    if (!id) { id = Math.random().toString(36).slice(2) + Date.now().toString(36); store(DEVICE_KEY, id); }
    return id;
  }
  // Gespeicherte Karte: status 'pending' (E-Mail noch nicht bestätigt) oder 'active' (Code läuft)
  function getAny() {
    try {
      var c = JSON.parse(store(STORE_KEY) || 'null');
      if (!c) return null;
      if (c.status === 'active' && Date.parse(c.expiresAt) > Date.now()) return c;
      if (c.status === 'verify' && Date.parse(c.confirmUntil) > Date.now()) return c;
      store(STORE_KEY, null);
    } catch (e) {}
    return null;
  }
  function getClaim() { var c = getAny(); return c && c.status === 'active' ? c : null; }
  function getPending() { var c = getAny(); return c && c.status === 'verify' ? c : null; }
  function saveClaim(c) { store(STORE_KEY, JSON.stringify(c)); }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstElementChild; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function left(iso) {
    var ms = Math.max(0, Date.parse(iso) - Date.now());
    var s = Math.floor(ms / 1000);
    return { ms: ms, h: Math.floor(s / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }
  function hms(iso, sep) { var t = left(iso); sep = sep || ':'; return pad(t.h) + sep + pad(t.m) + sep + pad(t.s); }
  function mmss(iso) { var t = left(iso); return pad(t.h * 60 + t.m) + ':' + pad(t.s); }
  function hoursText(iso) { var t = left(iso); return t.h > 0 ? Math.ceil(t.ms / 3600000) + ' h' : Math.max(1, t.m) + ' min'; }
  function postJSON(path, body) {
    return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function getJSON(path) { return fetch(API + path, { credentials: 'omit', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function euroNum(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  /* ── Zustand ── */
  var state = { cards: [], running: false };

  /* ── Saison-Leiste ── */
  function renderBar() {
    var bar = document.querySelector('.eldr-season-bar');
    if (!bar || !state.running) return;
    // Original-Banner (Text + Link zum Halloween-Drop) bleibt stehen, die Live-Anzeige kommt daneben
    if (bar.getAttribute('data-orig') === null) bar.setAttribute('data-orig', bar.innerHTML.trim());
    var orig = bar.getAttribute('data-orig');
    var claim = getClaim();
    var pend = getPending();
    var html;
    if (pend) {
      html = '<a class="eldr-t-bar" href="#" data-open-claim><span>Deine Karte ' + esc(pend.card.name) + ' ist reserviert</span><span class="eldr-t-bar__accent">Bestätigungscode eingeben · noch <span data-t-pend>' + mmss(pend.confirmUntil) + '</span></span></a>';
    } else if (claim) {
      html = '<a class="eldr-t-bar" href="#" data-open-claim><span>Deine Karte ' + esc(claim.card.name) + ' · ' + esc(claim.amount) + ' ist aktiv</span><span class="eldr-t-bar__accent">noch <span data-t-count>' + hms(claim.expiresAt, ' : ') + '</span></span></a>';
    } else {
      var open = state.cards.filter(function (c) { return c.status === 'open'; }).length;
      var dots = state.cards.map(function (c) { return '<span class="eldr-t-dot eldr-t-dot--' + (c.status === 'open' ? 'open' : 'gone') + '"></span>'; }).join('');
      html = '<a class="eldr-t-bar" href="/#eldr-jagd"><span>Tarot-Gutschein-Jagd</span><span class="eldr-t-bar__row"><span class="eldr-t-dots" aria-hidden="true">' + dots + '</span>' +
        '<span class="eldr-t-bar__accent">' + (open ? 'noch ' + open + ' von ' + state.cards.length + ' Karten zu finden' : 'alle Karten gefunden') + '</span></span></a>';
    }
    bar.innerHTML = '<span class="eldr-t-bar__wrap">' + (orig ? '<span class="eldr-t-bar__orig">' + orig + '</span><span class="eldr-t-bar__sep" aria-hidden="true"></span>' : '') + html + '</span>';
    var oc = bar.querySelector('[data-open-claim]');
    if (oc) oc.addEventListener('click', function (e) { e.preventDefault(); openMine(); });
  }

  /* ── Startseite ── */
  function statusText(c) {
    if (c.status === 'open') return 'Frei · noch zu finden';
    return 'Gefunden';
  }
  function renderHome() {
    var tpl = document.querySelector('template[data-eldr-tarot-home]');
    if (!tpl || !state.running) return;
    var sec = document.getElementById('eldr-jagd');
    if (!sec) {
      sec = tpl.content.firstElementChild.cloneNode(true);
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (!main) return;
      var hero = main.querySelector('.eldr-s-hero');
      var heroSection = hero && (hero.closest('.eldr-s-hero-wrap') || hero);
      if (heroSection && heroSection.parentNode) heroSection.parentNode.insertBefore(sec, heroSection.nextSibling);
      else main.insertBefore(sec, main.firstChild);
    }
    var wrap = sec.querySelector('[data-eldr-tarot-cards]');
    var srText = function (c) { return c.num + ' · ' + c.name + ': Gutschein über ' + c.amount + ' ab ' + c.min + ' Bestellwert. Hinweis: ' + c.hint + ' Status: ' + statusText(c) + '. Antippen zum Umdrehen.'; };
    // Karten nur einmal bauen; beim minütlichen Aktualisieren nur Status ändern, damit umgedrehte Karten und der Fokus bleiben
    var ids = state.cards.map(function (c) { return c.id; }).join(',');
    if (wrap.getAttribute('data-ids') === ids) {
      state.cards.forEach(function (c) {
        var cw = wrap.querySelector('[data-card="' + c.id + '"]');
        if (!cw) return;
        cw.querySelector('.eldr-t-card').classList.toggle('is-gone', c.status !== 'open');
        cw.querySelector('.eldr-t-sr').textContent = srText(c);
        var st = cw.querySelector('.eldr-t-status');
        st.className = 'eldr-t-status eldr-t-status--' + (c.status === 'open' ? 'open' : 'gone');
        st.textContent = statusText(c);
      });
      sec.hidden = false;
      jumpToHunt(sec);
      return;
    }
    wrap.setAttribute('data-ids', ids);
    wrap.innerHTML = state.cards.map(function (c) {
      return '<div class="eldr-t-cardwrap" data-card="' + esc(c.id) + '">' +
        '<button type="button" class="eldr-t-card' + (c.status !== 'open' ? ' is-gone' : '') + '">' +
          '<span class="eldr-t-sr">' + esc(srText(c)) + '</span>' +
          '<span class="eldr-t-card__in" aria-hidden="true">' +
            '<span class="eldr-t-card__face eldr-t-card__face--front"><span class="eldr-t-card__frame">' +
              '<span class="eldr-t-card__numeral">' + esc(c.num) + '</span>' +
              '<span class="eldr-t-card__circle">' + (SYM[c.id] || '') + '</span>' +
              '<span class="eldr-t-card__name">' + esc(c.name) + '</span>' +
              '<span class="eldr-t-card__turn">' + TURN + 'Umdrehen</span>' +
            '</span></span>' +
            '<span class="eldr-t-card__face eldr-t-card__face--back"><span class="eldr-t-card__frame">' +
              '<span class="eldr-t-card__label">' + esc(c.num) + ' · ' + esc(c.name) + '</span>' +
              '<span class="eldr-t-card__offer"><span class="eldr-t-card__amount">' + esc(c.amount) + '</span>' +
              '<span class="eldr-t-card__min">ab ' + esc(c.min) + ' Bestellwert</span>' +
              '<span class="eldr-t-card__hint">' + esc(c.hint) + '</span></span>' +
              '<span class="eldr-t-card__turn">' + TURN + 'Zurückdrehen</span>' +
            '</span></span>' +
          '</span>' +
        '</button>' +
        '<span class="eldr-t-status eldr-t-status--' + (c.status === 'open' ? 'open' : 'gone') + '" aria-hidden="true">' + statusText(c) + '</span>' +
      '</div>';
    }).join('');
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    wrap.querySelectorAll('.eldr-t-card').forEach(function (b) {
      var turnT;
      b.addEventListener('click', function () {
        b.classList.toggle('is-flipped');
        if (calm) return;
        // Karte hebt sich beim Drehen an und legt sich danach wieder ab
        b.classList.add('is-turning');
        clearTimeout(turnT);
        turnT = setTimeout(function () { b.classList.remove('is-turning'); }, 1150);
      });
      if (calm || !finePointer) return;
      // Leichte Neigung zur Maus, wie eine Karte, die man in der Hand hält
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        b.classList.add('is-tilting');
        b.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        b.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
      });
      b.addEventListener('pointerleave', function () {
        b.classList.remove('is-tilting');
        b.style.setProperty('--ry', '0deg');
        b.style.setProperty('--rx', '0deg');
      });
    });
    sec.hidden = false;
    jumpToHunt(sec);
  }

  /* ── Grimoire-Zeile auf Produktseiten ── */
  function renderGrimoireLine() {
    var card = document.querySelector('.eldr-pe-card--grimoire');
    if (!card || !state.running || card.querySelector('.eldr-pe-tarot')) return;
    var open = state.cards.filter(function (c) { return c.status === 'open'; }).length;
    var dots = state.cards.map(function (c) { return '<span class="eldr-t-dot eldr-t-dot--' + (c.status === 'open' ? 'open' : 'gone') + '"></span>'; }).join('');
    var text = open === 0 ? 'Alle Karten sind gefunden.' : open === 1 ? 'Eine Karte ist noch versteckt.' : open + ' Karten sind noch versteckt.';
    card.appendChild(el('<div class="eldr-pe-tarot"><span><span class="eldr-t-dots" aria-hidden="true">' + dots + '</span>' + text + '</span><a href="/#eldr-jagd">Zur Tarot-Gutschein-Jagd</a></div>'));
  }

  // Link /#eldr-jagd: erst springen, wenn die Sektion wirklich sichtbar ist (sie wird spät eingefügt)
  var jumped = false;
  function jumpToHunt(sec) {
    if (jumped || location.hash !== '#eldr-jagd') return;
    jumped = true;
    requestAnimationFrame(function () { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }

  /* ── Footer-Kerze: brennt den ganzen Tag, nachts (22–3 Uhr) erscheint der Mond auf dem Wachs ── */
  function renderCandle() {
    if (!state.running || document.querySelector('.eldr-t-candles')) return;
    var footer = (document.querySelector('footer.site-footer') || document.querySelector('.site-footer') || document.querySelector('footer'));
    if (!footer) return;
    if (getComputedStyle(footer).position === 'static') footer.style.position = 'relative';
    // Kerzen wie im Hero (gleiche Klassen aus eldr-season.css), links und rechts unten im Footer.
    // Nachts (22–3 Uhr) erscheint der Mond auf einer davon, sie ist nicht hervorgehoben.
    var c = function (w, h, moon) {
      return '<span class="eldr-s-candle"><span class="eldr-s-candle__flame"></span><span class="eldr-s-candle__wax' + (moon ? ' eldr-t-moonwax' : '') + '" style="width:' + w + 'px;height:' + h + 'px"></span></span>';
    };
    footer.appendChild(el('<div class="eldr-t-candles eldr-t-candles--l" aria-hidden="true">' + c(18, 110) + c(14, 64) + '</div>'));
    footer.appendChild(el('<div class="eldr-t-candles eldr-t-candles--r" aria-hidden="true">' + c(14, 78) + c(24, 132, true) + c(12, 50) + '</div>'));
  }

  /* ── Versteckte Symbole ── */
  function slotHost(slot) {
    if (slot === 'grimoire') return document.querySelector('.eldr-pe-card--grimoire') || document.querySelector('.eldr-pe-card');
    if (slot === 'footer') return document.querySelector('.eldr-t-moonwax') || (document.querySelector('footer.site-footer') || document.querySelector('.site-footer') || document.querySelector('footer'));
    if (slot === 'banner') {
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (!main) return null;
      var h1 = main.querySelector('h1');
      return h1 ? (h1.closest('.shopify-section') || h1.parentElement) : main.firstElementChild;
    }
    return null;
  }

  function placeSymbol(spot) {
    if (spot.slot === 'search') return placeSearchHit(spot);
    var host = slotHost(spot.slot);
    if (!host || host.querySelector('[data-eldr-t-hidden="' + spot.card + '"]')) return !!host;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var btn = el('<button type="button" class="eldr-t-hidden eldr-t-hidden--' + esc(spot.slot) + '" data-eldr-t-hidden="' + esc(spot.card) + '" aria-label="Kleines goldenes Zeichen">' + (SYM[spot.card] || '') + '</button>');
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openFound(spot); });
    if (spot.slot === 'grimoire') {
      // Im Textfluss am Ende der Grimoire-Legende, damit nichts mit der Jagd-Zeile darunter überlappt
      var inline = host.querySelector('.eldr-pe-lore') || host.querySelector('.eldr-pe-title');
      if (inline) { btn.classList.add('eldr-t-hidden--inline'); inline.appendChild(btn); } else host.appendChild(btn);
    } else {
      if (host.classList.contains('eldr-t-moonwax')) { btn.classList.add('eldr-t-hidden--candle'); host.closest('.eldr-t-candles').removeAttribute('aria-hidden'); }
      host.appendChild(btn);
    }

    if (spot.slot === 'banner') {
      // Laterne: Symbol fast unsichtbar, leuchtet in der Nähe von Maus oder Finger auf
      var placeBtn = function () {
        var r = host.getBoundingClientRect();
        btn.style.left = Math.round(r.width * 0.78) + 'px';
        btn.style.top = Math.round(Math.max(24, r.height * 0.42)) + 'px';
      };
      placeBtn();
      window.addEventListener('resize', placeBtn);
      var glow = el('<span class="eldr-t-lantern" aria-hidden="true"></span>');
      host.appendChild(glow);
      var fadeTimer = null;
      var move = function (x, y) {
        clearTimeout(fadeTimer);
        var hr = host.getBoundingClientRect();
        var br = btn.getBoundingClientRect();
        glow.style.left = (x - hr.left) + 'px';
        glow.style.top = (y - hr.top) + 'px';
        glow.style.opacity = '1';
        var d = Math.hypot(x - (br.left + br.width / 2), y - (br.top + br.height / 2));
        btn.style.opacity = String(Math.max(0.05, Math.min(1, 1 - (d - 50) / 170)));
      };
      var dim = function (delay) {
        clearTimeout(fadeTimer);
        fadeTimer = setTimeout(function () { glow.style.opacity = '0'; btn.style.opacity = '.05'; }, delay);
      };
      host.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); });
      host.addEventListener('pointerdown', function (e) { move(e.clientX, e.clientY); });
      // Finger: Antippen oder Wischen beleuchtet die Stelle und das Licht bleibt kurz stehen
      host.addEventListener('touchstart', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
      host.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
      host.addEventListener('touchend', function () { dim(1800); }, { passive: true });
      host.addEventListener('pointerleave', function (e) { dim(e.pointerType === 'mouse' ? 0 : 1800); });
    }
    return true;
  }

  /* Spiegelwort: wer das Wort aus dem Obsidian-Grimoire richtig herum sucht, findet den Eremiten als Suchergebnis */
  function searchHitEl(spot, extra) {
    var hit = el('<div class="eldr-t-searchhit' + (extra || '') + '"><button type="button" class="eldr-t-searchhit__btn" data-eldr-t-hidden="' + esc(spot.card) + '">' +
      '<span class="eldr-t-searchhit__sym" aria-hidden="true">' + (SYM[spot.card] || '') + '</span>' +
      '<span class="eldr-t-searchhit__text"><span class="eldr-t-searchhit__eyebrow">' + (getAny() ? 'Du hast schon gezogen' : 'Ein Ergebnis, das nicht im Katalog steht') + '</span>' +
      '<span class="eldr-t-searchhit__title">Jemand hat dich gehört.</span>' +
      '<span class="eldr-t-searchhit__sub">' + (getAny() ? 'Jede:r darf nur eine Karte ziehen. Tippe, um deine zu sehen.' : 'Tippe auf das Zeichen.') + '</span></span></button></div>');
    hit.querySelector('button').addEventListener('click', function (e) { e.preventDefault(); openFound(spot); });
    return hit;
  }
  function placeSearchHit(spot) {
    if (document.querySelector('[data-eldr-t-hidden="' + spot.card + '"]')) return true;
    var main = document.getElementById('MainContent') || document.querySelector('main');
    var h1 = main && main.querySelector('h1');
    if (!h1) return false;
    (h1.closest('.template-title--wrapper') || h1).insertAdjacentElement('afterend', searchHitEl(spot));
    return true;
  }

  // Suchvorschau im Header: bei exakt dem Spiegelwort erscheint das Ergebnis schon beim Tippen
  function watchPredictive() {
    var t, last = '';
    document.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches('predictive-search input[name="q"]')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var v = inp.value.trim().toLowerCase();
        var box = inp.closest('predictive-search');
        var old = box.querySelector('.eldr-t-searchhit--predictive');
        if (v === last) return;
        last = v;
        if (old) old.remove();
        if (v.length < 4 || !state.running) return; // kurze Eingaben fragen den Server gar nicht erst
        getJSON('/spots?path=/search&q=' + encodeURIComponent(v)).then(function (d) {
          if (inp.value.trim().toLowerCase() !== v) return;
          var spot = (d.spots || []).filter(function (x) { return x.slot === 'search'; })[0];
          if (box.querySelector('.eldr-t-searchhit--predictive')) return;
          var bar = box.querySelector('.predictive-search__search-bar') || inp.parentElement;
          var hit;
          if (spot) {
            hit = searchHitEl(spot, ' eldr-t-searchhit--predictive');
            hit.setAttribute('role', 'status'); // Screenreader sagen, dass beim Tippen etwas aufgetaucht ist
          } else if (d.nudge) {
            hit = nudgeEl(d.nudge, ' eldr-t-searchhit--predictive'); // leiser Hinweis auch schon in der Vorschau
          }
          if (hit) bar.insertAdjacentElement('afterend', hit);
        }).catch(function () {});
      }, 450);
    }, true); // capture: das Theme stoppt das Event evtl. selbst
  }

  // Fast-Treffer in der Suche: leiser Hinweis statt Stille
  function nudgeEl(kind, extra) {
    var text = kind === 'mirror' ? 'Fast. Ein Spiegel zeigt alles verkehrt herum.' : 'Ein Bruchstück allein ruft ihn nicht.';
    return el('<div class="eldr-t-searchhit eldr-t-searchhit--nudge' + (extra || '') + '" role="status"><span class="eldr-t-searchhit__sym" aria-hidden="true">' + SYM.c + '</span><span class="eldr-t-searchhit__text"><span class="eldr-t-searchhit__eyebrow">Eine Stimme aus dem Dunkeln</span><span class="eldr-t-searchhit__sub">' + text + '</span></span></div>');
  }
  function showNudge(kind) {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    var h1 = main && main.querySelector('h1');
    if (!h1 || main.querySelector('.eldr-t-searchhit')) return;
    (h1.closest('.template-title--wrapper') || h1).insertAdjacentElement('afterend', nudgeEl(kind));
  }

  // Spiegelwort in drei Splittern: jedes dieser Obsidian-Grimoires zeigt nur ein Bruchstück
  var SHARDS = {
    '/products/shadow-keeper-obsidian-schaedel': 'III · THCI',
    '/products/dark-mirror-obsidian-kugel': 'II · LNEN',
    '/products/obsidian-fledermaeuse': 'I · RETAL'
  };
  function renderMirror() {
    var shard = SHARDS[(location.pathname.replace(/\/+$/, '').match(/\/products\/[^/]+$/) || [''])[0]];
    var card = document.querySelector('.eldr-pe-card--grimoire');
    if (!shard || !card || !state.running || card.querySelector('.eldr-t-mirror')) return;
    var lore = card.querySelector('.eldr-pe-lore');
    if (!lore) return;
    var c = state.cards.filter(function (x) { return x.id === 'c'; })[0];
    if (!c || c.status === 'gone') return;
    lore.appendChild(el('<span class="eldr-t-mirrorline"> Auf dieser Scheibe stand nur ein Bruchstück: <span class="eldr-t-mirror">' + shard + '</span></span>'));
  }

  function loadSpots() {
    // Symbole auch zeigen, wenn man schon eine Karte hat: ein Klick öffnet dann die eigene Karte (openFound → openMine)
    var q = new URLSearchParams(location.search).get('q') || '';
    getJSON('/spots?path=' + encodeURIComponent(cfg.path || location.pathname) + (q ? '&q=' + encodeURIComponent(q) : '')).then(function (d) {
      if (d.nudge) showNudge(d.nudge); // der Server schickt den Hinweis nur, wenn das Wort nicht ganz stimmt
      (d.spots || []).forEach(function (spot) {
        if (placeSymbol(spot)) return;
        // Ziel noch nicht da (z. B. Grimoire wird erst per Script eingefügt): kurz warten
        var tries = 0;
        var iv = setInterval(function () { if (placeSymbol(spot) || ++tries > 20) clearInterval(iv); }, 300);
      });
    }).catch(function () {});
  }

  /* ── Fenster ── */
  var modal, timerIv, lastFocus;
  function ensureModal() {
    if (modal) return modal;
    var tpl = document.querySelector('template[data-eldr-tarot-modal]');
    if (!tpl) return null;
    modal = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(modal);
    modal.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    modal.querySelector('[data-copy]').addEventListener('click', function () {
      var code = modal.querySelector('[data-code]').textContent;
      var btn = this;
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
        btn.textContent = 'Kopiert'; setTimeout(function () { btn.textContent = 'Kopieren'; }, 1800);
      }).catch(function () {});
    });
    return modal;
  }
  function show(view) {
    modal.querySelectorAll('.eldr-t-view').forEach(function (v) { v.hidden = v.getAttribute('data-view') !== view; });
  }
  // Fenster ist modal: Escape schließt, Tab bleibt im Fenster, der Rest der Seite ist solange inaktiv
  function onModalKey(e) {
    if (!modal || modal.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(modal.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'), function (n) { return !n.disabled && n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!modal.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function setInert(on) {
    Array.prototype.forEach.call(document.body.children, function (n) {
      if (n === modal || n.tagName === 'SCRIPT' || n.tagName === 'TEMPLATE') return;
      if (on) { if (!n.inert) { n.inert = true; n.setAttribute('data-eldr-t-inert', ''); } }
      else if (n.hasAttribute('data-eldr-t-inert')) { n.inert = false; n.removeAttribute('data-eldr-t-inert'); }
    });
  }
  function openModal(view) {
    if (!ensureModal()) return;
    if (modal.hidden) lastFocus = document.activeElement;
    modal.querySelector('[data-already]').hidden = true;
    document.addEventListener('keydown', onModalKey);
    setInert(true);
    show(view);
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var f = modal.querySelector('.eldr-t-view:not([hidden]) input, .eldr-t-view:not([hidden]) .eldr-t-btn'); if (f) f.focus(); }, 50);
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.removeEventListener('keydown', onModalKey);
    setInert(false);
    document.documentElement.style.overflow = '';
    clearInterval(timerIv);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openFound(spot) {
    if (!ensureModal()) return;
    if (getAny()) { openMine(); modal.querySelector('[data-already]').hidden = false; return; }
    modal.querySelector('[data-sym]').innerHTML = SYM[spot.card] || '';
    // Fund-Moment: Karte dreht sich um und zeigt, was man gewonnen hat, erst darunter die E-Mail
    var info = (state.cards || []).filter(function (x) { return x.id === spot.card; })[0];
    var fcard = modal.querySelector('[data-fcard]');
    modal.querySelector('[data-found-amount]').textContent = info ? info.amount : '';
    modal.querySelector('[data-found-min]').textContent = info ? 'ab ' + info.min + ' Bestellwert' : '';
    fcard.classList.toggle('has-back', !!info);
    fcard.classList.remove('is-shown');
    void fcard.offsetWidth;
    setTimeout(function () { fcard.classList.add('is-shown'); }, 650);
    modal.querySelector('[data-cardline]').textContent = spot.num + ' · ' + spot.name;
    modal.querySelector('[data-found-title]').textContent = 'Du hast ' + spot.name.replace(/^Die /, 'die ').replace(/^Der Eremit$/, 'den Eremiten').replace(/^Der /, 'den ') + ' gefunden.';
    var form = modal.querySelector('[data-form]');
    var err = modal.querySelector('[data-error]');
    err.hidden = true;
    form.onsubmit = function (e) {
      e.preventDefault();
      var email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; err.hidden = false; form.email.focus(); return; }
      var btn = form.querySelector('[data-submit]');
      btn.disabled = true; btn.textContent = 'Wird gesendet …'; err.hidden = true;
      fetch(API + '/claim', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit',
        body: JSON.stringify({ token: spot.token, email: email, newsletter: !!form.newsletter.checked, device: deviceId() })
      }).then(function (r) { return r.json(); }).then(function (d) {
        btn.disabled = false; btn.textContent = 'Karte für mich reservieren';
        if (d.ok) {
          d.email = email;
          d.sentAt = Date.now();
          d.spot = spot; // für „E-Mail ändern“
          saveClaim(d);
          document.querySelectorAll('[data-eldr-t-hidden]').forEach(function (n) { n.remove(); });
          openMine();
          refresh();
          return;
        }
        message(d.reason, d, spot);
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Karte für mich reservieren';
        err.textContent = 'Keine Verbindung zum Versteck. Prüf kurz dein Internet und tipp nochmal auf „Karte für mich reservieren“.'; err.hidden = false;
      });
    };
    if (spot.prefill) { form.email.value = spot.prefill; delete spot.prefill; }
    if (modal.hidden) openModal('email'); else { show('email'); setTimeout(function () { form.email.focus(); form.email.select(); }, 60); }
  }

  function message(reason, d, spot) {
    var m = {
      taken: ['Jemand war schneller.', 'Diese Karte hat schon jemand anderes gefunden. Vielleicht wartet eine der anderen noch auf dich.'],
      already: ['Du hast schon eine Karte gefunden.', 'Pro Person gibt es eine Karte, so bleibt die Jagd fair für alle. Die übrigen Karten warten auf die anderen aus der Community.'],
      rate: ['Kurz durchatmen.', 'Zu viele Versuche auf einmal. Versuch es in einer Stunde nochmal.'],
      token: ['Das Symbol ist verblasst.', 'Lade die Seite neu und tippe noch einmal darauf.'],
      closed: ['Die Jagd ruht gerade.', 'Die Tarot-Gutschein-Jagd läuft nur während des Halloween-Drops.'],
      server: ['Die Geister streiken.', 'Gerade klappt es nicht. Versuch es bitte gleich nochmal.'],
      expiredpending: ['Die Karte ist zurück im Versteck.', 'Der Bestätigungscode wurde nicht rechtzeitig eingegeben. Vielleicht findest du sie ja noch einmal.'],
      linkold: ['Dieser Link gilt nicht mehr.', 'Du hast inzwischen einen neueren Bestätigungscode bekommen oder er ist abgelaufen. Nimm bitte den Link aus der neuesten Mail.'],
      too_many: ['Zu oft falsch eingegeben.', 'Aus Sicherheitsgründen ist die Karte zurück im Versteck. Vielleicht findest du sie ja noch einmal.']
    }[reason] || ['Die Geister streiken.', 'Gerade klappt es nicht. Versuch es bitte gleich nochmal.'];
    if (!ensureModal()) return;
    modal.querySelector('[data-msg-eyebrow]').textContent = spot ? spot.num + ' · ' + spot.name : '';
    modal.querySelector('[data-msg-title]').textContent = m[0];
    modal.querySelector('[data-msg-text]').textContent = m[1];
    modal.querySelector('[data-msg-insta]').hidden = !(reason === 'taken' || reason === 'expiredpending' || reason === 'too_many');
    if (modal.hidden) openModal('msg'); else show('msg');
  }

  // Öffnet je nach Zustand die Bestätigungs- oder die Code-Ansicht
  function openMine() {
    var p = getPending();
    if (p) return openOtp(p);
    var c = getClaim();
    if (c) return openCode(c);
  }

  var resendIv;
  function openOtp(p) {
    if (!ensureModal()) return;
    modal.querySelector('[data-otp-mail]').textContent = p.email || 'deine E-Mail-Adresse';
    modal.querySelector('[data-otp-amount]').textContent = p.amount;
    var change = modal.querySelector('[data-change-mail]');
    change.hidden = !p.spot;
    change.onclick = function () {
      change.disabled = true;
      postJSON('/cancel', { ticket: p.ticket }).catch(function () {}).then(function () {
        change.disabled = false;
        clearInterval(timerIv); clearInterval(resendIv);
        store(STORE_KEY, null); renderBar(); renderPill(); refresh();
        var spot = p.spot; spot.prefill = p.email;
        openFound(spot);
      });
    };
    var form = modal.querySelector('[data-otp-form]');
    var err = modal.querySelector('[data-otp-error]');
    var btn = modal.querySelector('[data-otp-submit]');
    var resend = modal.querySelector('[data-resend]');
    err.hidden = true;
    form.otp.value = '';
    var tick = function () {
      var cur = getAny();
      if (!cur) { clearInterval(timerIv); message('expiredpending'); return; }
      if (cur.status === 'active') { clearInterval(timerIv); openCode(cur); return; }
      modal.querySelector('[data-otp-timer]').textContent = mmss(cur.confirmUntil);
    };
    tick();
    clearInterval(timerIv);
    timerIv = setInterval(tick, 1000);
    form.otp.oninput = function () {
      form.otp.value = form.otp.value.replace(/\D/g, '').slice(0, 6);
      if (form.otp.value.length === 6) form.requestSubmit();
    };
    form.onsubmit = function (e) {
      e.preventDefault();
      var otp = form.otp.value.replace(/\D/g, '');
      if (otp.length !== 6) { err.textContent = 'Der Bestätigungscode hat 6 Ziffern.'; err.hidden = false; return; }
      if (btn.disabled) return;
      btn.disabled = true; btn.textContent = 'Wird geprüft …'; err.hidden = true;
      postJSON('/verify', { ticket: p.ticket, otp: otp }).then(function (d) {
        btn.disabled = false; btn.textContent = 'Bestätigen und Gutschein erhalten';
        if (d.ok && d.status === 'active') {
          p.status = 'active'; p.code = d.code; p.expiresAt = d.expiresAt; p.sentAt = Date.now();
          saveClaim(p);
          renderBar(); renderPill(); renderCartHint(); refresh();
          openCode(p);
          return;
        }
        if (d.reason === 'otp_wrong') { err.textContent = 'Der Bestätigungscode stimmt nicht. Noch ' + d.left + (d.left === 1 ? ' Versuch.' : ' Versuche.'); err.hidden = false; form.otp.select(); return; }
        if (d.reason === 'otp_expired') { err.textContent = 'Der Bestätigungscode ist abgelaufen. Lass dir einen neuen schicken.'; err.hidden = false; return; }
        if (d.reason === 'too_many') { store(STORE_KEY, null); renderBar(); renderPill(); message('too_many'); return; }
        if (d.reason === 'expired') { store(STORE_KEY, null); renderBar(); renderPill(); message('expiredpending'); return; }
        err.textContent = 'Gerade klappt es nicht. Versuch es bitte gleich nochmal.'; err.hidden = false;
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Bestätigen und Gutschein erhalten';
        err.textContent = 'Keine Verbindung zum Versteck. Dein Bestätigungscode bleibt gültig, tipp gleich nochmal auf „Bestätigen“.'; err.hidden = false;
      });
    };
    var cooldown = function (sec) {
      clearInterval(resendIv);
      var left = sec;
      resend.disabled = true;
      resend.textContent = 'Neuen Code in ' + left + ' s';
      resendIv = setInterval(function () {
        left--;
        if (left <= 0) { clearInterval(resendIv); resend.disabled = false; resend.textContent = 'Bestätigungscode erneut senden'; return; }
        resend.textContent = 'Neuen Code in ' + left + ' s';
      }, 1000);
    };
    resend.onclick = function () {
      if (resend.disabled) return;
      resend.disabled = true;
      postJSON('/resend', { ticket: p.ticket }).then(function (d) {
        if (d.ok) { err.hidden = true; cooldown(45); resend.blur(); return; }
        if (d.reason === 'resend_wait') { cooldown(d.wait || 30); return; }
        if (d.reason === 'resend_limit') { resend.disabled = true; resend.textContent = 'Kein weiterer Bestätigungscode möglich'; return; }
        if (d.reason === 'expired') { store(STORE_KEY, null); message('expiredpending'); return; }
        resend.disabled = false;
        err.textContent = 'Gerade klappt es nicht. Versuch es bitte gleich nochmal.'; err.hidden = false;
      }).catch(function () { resend.disabled = false; });
    };
    var sentAgo = (Date.now() - (p.sentAt || 0)) / 1000;
    if (sentAgo < 45) cooldown(Math.ceil(45 - sentAgo)); else { clearInterval(resendIv); resend.disabled = false; resend.textContent = 'Bestätigungscode erneut senden'; }
    if (modal.hidden) openModal('otp'); else show('otp');
    setTimeout(function () { form.otp.focus(); }, 60);
  }

  function openCode(c) {
    if (!c || !ensureModal()) return;
    modal.querySelector('[data-amount]').textContent = c.amount;
    modal.querySelector('[data-min]').textContent = c.min;
    modal.querySelector('[data-code]').textContent = c.code;
    modal.querySelector('[data-win-num]').textContent = c.card ? c.card.num : '';
    modal.querySelector('[data-win-name]').textContent = c.card ? c.card.name : '';
    modal.querySelector('[data-win-sym]').innerHTML = c.card ? (SYM[c.card.id] || '') : '';
    var until = new Date(c.expiresAt);
    modal.querySelector('[data-valid-until]').textContent = until.toLocaleString('de-DE', { weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' }) + ' Uhr';
    var redirect = cfg.applyRedirect || '/collections/halloween-drop';
    modal.querySelector('[data-apply]').href = '/discount/' + encodeURIComponent(c.code) + '?redirect=' + encodeURIComponent(redirect);
    var tick = function () {
      var t = left(c.expiresAt);
      modal.querySelector('[data-timer]').textContent = pad(t.h) + ':' + pad(t.m) + ':' + pad(t.s);
      if (t.ms <= 0) { clearInterval(timerIv); store(STORE_KEY, null); }
    };
    tick();
    clearInterval(timerIv);
    timerIv = setInterval(tick, 1000);
    if (modal.hidden) openModal('code'); else show('code');
  }

  /* ── Timer-Anzeige unten links ── */
  var pill;
  function renderPill() {
    var c = getAny();
    if (!c) { if (pill) { pill.remove(); pill = null; } return; }
    var mode = c.status;
    if (pill && pill.getAttribute('data-mode') !== mode) { pill.remove(); pill = null; }
    if (!pill) {
      var label = mode === 'verify' ? 'Bestätigungscode eingeben' : esc(c.amount) + ' gehören dir';
      pill = el('<button type="button" class="eldr-t-pill" data-mode="' + mode + '" aria-label="Deine Karte ansehen">' + (SYM[c.card.id] || '') + '<span>' + label + '</span><span class="eldr-t-pill__time" data-t-pill></span></button>');
      pill.addEventListener('click', openMine);
      document.body.appendChild(pill);
    }
    pill.querySelector('[data-t-pill]').textContent = mode === 'verify' ? mmss(c.confirmUntil) : hms(c.expiresAt);
  }

  /* ── Hinweis im Warenkorb ── */
  var cartBusy = false;
  function renderCartHint() {
    var c = getClaim();
    var body = document.querySelector('cart-drawer .global-drawer__body');
    var old = body && body.querySelector('.eldr-t-cart');
    if (!c || !body) { if (old) old.remove(); return; }
    if (cartBusy) return;
    cartBusy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      cartBusy = false;
      if (!cart.item_count) { if (old) old.remove(); return; }
      var total = cart.total_price / 100;
      var missing = Math.max(0, c.minValue - total);
      var text;
      if (missing > 0) text = 'Noch <strong>' + euroNum(missing) + '</strong> bis ' + esc(c.min) + ', dann wird dein Gutschein abgezogen.';
      else text = 'Geschafft: Dein Gutschein über <strong>' + esc(c.amount) + '</strong> wird an der Kasse abgezogen.';
      var pct = Math.max(4, Math.min(100, total / c.minValue * 100));
      var key = [Math.round(missing * 100), c.code].join('|'); // Mindestwert zählt den ganzen Warenkorb
      var cur0 = body.querySelector('.eldr-t-cart');
      if (cur0 && cur0.getAttribute('data-k') === key) return;
      var html = '<div class="eldr-t-cart" data-k="' + key + '"><div class="eldr-t-cart__head"><span class="eldr-t-cart__title">' + esc(c.card.name) + ' · <span class="eldr-t-cart__amt">' + esc(c.amount) + '</span></span><span class="eldr-t-cart__time" data-t-cart>' + hms(c.expiresAt) + '</span></div>' +
        '<span class="eldr-t-cart__text">' + text + '</span><span class="eldr-t-cart__bar"><span style="width:' + pct + '%"></span></span>' +
        (missing <= 0 ? '' : '<a href="' + esc(cfg.applyRedirect || '/collections/halloween-drop') + '">Zum Halloween-Drop</a>') + '</div>';
      var cur = body.querySelector('.eldr-t-cart');
      if (cur) cur.outerHTML = html; else body.insertBefore(el(html), body.firstChild);
    }).catch(function () { cartBusy = false; });
  }

  /* ── Ablauf ── */
  function refresh() {
    return getJSON('/state').then(function (d) {
      state = d;
      // Gespeicherte Karte mit dem Server abgleichen: ist die Karte wieder frei oder eingelöst,
      // gilt der Fund in diesem Browser nicht mehr (z. B. abgelaufen oder vom Team zurückgesetzt)
      var mine = getAny();
      var fresh = mine && mine.sentAt && Date.now() - mine.sentAt < 120000;
      if (mine && mine.card && state.cards && !fresh) {
        var sc = state.cards.filter(function (x) { return x.id === mine.card.id; })[0];
        if (!sc || sc.status === 'open' || sc.status === 'gone') store(STORE_KEY, null);
      }
      // Jeder Teil einzeln abgesichert: ein Fehler (z. B. in der Leiste) darf Kerzen & Co. nicht verhindern
      [renderCandle, renderBar, renderHome, renderGrimoireLine, renderMirror, renderPill].forEach(function (fn) {
        try { fn(); } catch (e) { if (window.console) console.warn('eldr-tarot', e); }
      });
    }).catch(function () {});
  }

  // Bestätigen-Link aus der Mail (?eldr_t=…&eldr_c=…): klappt auch in einem anderen Browser oder aus der Mail-App
  function verifyFromLink() {
    var q = new URLSearchParams(location.search);
    var t = q.get('eldr_t'), c = q.get('eldr_c');
    if (!t || !c) return;
    q.delete('eldr_t'); q.delete('eldr_c');
    try { history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash); } catch (e) {}
    postJSON('/verify', { ticket: t, otp: c }).then(function (d) {
      if (d.ok && d.status === 'active') {
        var claim = { status: 'active', ticket: t, code: d.code, expiresAt: d.expiresAt, card: d.card, amount: d.amount, min: d.min, minValue: d.minValue };
        saveClaim(claim);
        refresh();
        renderCartHint();
        openCode(claim);
        return;
      }
      if (d.reason === 'otp_expired') {
        var p = getPending();
        if (p && p.ticket === t) { openOtp(p); return; }
        message('linkold');
        return;
      }
      if (d.reason === 'too_many') { store(STORE_KEY, null); message('too_many'); return; }
      message(d.reason === 'otp_wrong' ? 'linkold' : 'expiredpending');
    }).catch(function () { message('server'); });
  }

  function start() {
    verifyFromLink();
    refresh().then(function () {
      if (state.running) { loadSpots(); watchPredictive(); }
      if (getPending() && (!modal || modal.hidden)) openMine();
    });
    setInterval(function () {
      var c = getClaim();
      document.querySelectorAll('[data-t-count]').forEach(function (n) { if (c) n.textContent = hms(c.expiresAt, ' : '); });
      document.querySelectorAll('[data-t-cart]').forEach(function (n) { if (c) n.textContent = hms(c.expiresAt); });
      var pd = getPending();
      document.querySelectorAll('[data-t-pend]').forEach(function (n) { if (pd) n.textContent = mmss(pd.confirmUntil); });
      renderPill();
    }, 1000);
    setInterval(refresh, 60000);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function (muts) {
        if (pending) return;
        var relevant = muts.some(function (m) { return !(m.target.closest && m.target.closest('.eldr-t-cart')); });
        if (!relevant) return;
        pending = true;
        setTimeout(function () { pending = false; renderCartHint(); }, 250);
      }).observe(drawer, { childList: true, subtree: true });
      renderCartHint();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
